import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { OptionTypeBase, ValueType } from 'react-select';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { applicationOptions } from '../../../stores/applications/selectors';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected, selectedOne, singleSelected } from '../../../stores/tables/selectors';
import { assignApplicationsWorkspace } from '../../../stores/workspaces/actionCreators';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected?: string;
    applications: Array<{ label: string, value: string }>;
    selectedOne: boolean;

    assignApplicationsWorkspace: (applicationIds: string[], workspaceIds: string) => void;
}

interface State {
    showModal: boolean;
    selection?: ValueType<{ label: string, value: string }> | null;
}

class AssignApplicationsWorkspaceAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            selection: [],
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.selectedOne && this.props.hasPrivilege(['ASSIGN_APPLICATION_WORKSPACE', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="no-icon"
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        {t('workspaces.button.assignApplications')}
                    </DropdownItem>
                    <ConfirmModal
                        className="overflow-visible"
                        header={t('workspaces.modal.assignApplications.header') as string}
                        confirmText={t('modal.assign') as string}
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.assign();
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        <p>{t('workspaces.modal.assignApplications.text') as string}</p>
                        <Select className={"dropdown-select application-select"}
                            isMulti={false}
                            options={this.props.applications}
                            value={this.state.selection}
                            onChange={this.handleSelectChange}
                        />
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private handleSelectChange = (val?: ValueType<{ label: string, value: string }>) => {
        this.setState({ selection: (val === null || val === undefined) ? [] : val });
    }

    private assign = () => {
        if (this.state.selection && Array.isArray(this.state.selection) && this.state.selection.length > 0) {
            this.props.assignApplicationsWorkspace(
                this.state.selection.map((option) => option.value),
                this.props.selected!,
            );
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    applications: applicationOptions(state),
    hasPrivilege: hasPrivilege(state),
    selected: singleSelected(state, 'workspaces'),
    selectedOne: selectedOne(state, 'workspaces'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    assignApplicationsWorkspace: (applicationIds: string[], workspaceId: string) =>
        dispatch(assignApplicationsWorkspace(applicationIds, workspaceId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(AssignApplicationsWorkspaceAction));